import { makeAutoObservable } from 'mobx';
import { BUILD_NUMBER } from '../constant/config';
import { UserType } from '../state/UserState';

class UserStore {
  MIGRATION_KEY = 'userMigrationKey';
  STORAGE_KEY = 'ccUser'; // old key is venueUser - do not reuse, need to clear key
  DEPR_STORAGE_KEY = 'venueUser';

  constructor() {
    makeAutoObservable(this);
  }

  migrateStore() {
    let needsMigration =
      localStorage.getItem(this.MIGRATION_KEY) !== BUILD_NUMBER;

    console.log('UserStore needs migration ? ' + needsMigration);

    if (needsMigration) {
      this.clearStore();
      localStorage.setItem(this.MIGRATION_KEY, BUILD_NUMBER);
    }

    return needsMigration;
  }

  getUser() {
    let user = localStorage.getItem(this.STORAGE_KEY);

    if (user == null) return null;

    console.log(user);

    return JSON.parse(user);
  }

  getUserId() {
    let user = localStorage.getItem(this.STORAGE_KEY);

    if (user == null) return null;

    return JSON.parse(user).userId;
  }

  storeUser(user: UserType) {
    console.log('Store User');
    console.log(user);

    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(user));
  }

  clearStore() {
    localStorage.removeItem(this.STORAGE_KEY);
    localStorage.removeItem(this.DEPR_STORAGE_KEY);
  }
}

export default new UserStore();
